export default __webpack_public_path__ + "static/media/copy.32cd70ce.svg";